import styled from '@emotion/styled';

export const TimeslotTitle = styled.div`
  margin: 16px 0;
  color: #616569;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
`;
